import type { ProductColors } from '../../../../tokens/colors/types';

export const deals: ProductColors['deals'] = {
  '30': '#DA3835',
  '40': '#F9700D',
};

export const retail: ProductColors['retail'] = {
  '10': '#FEF3EB',
  '20': '#FCEEEF',
  '30': '#F9700D',
  '50': '#DA3835',
};
